import React from 'react';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';

export default function FirstMessageContent({
    tabNameChatAI,
}) {


    return (
        <div className="first-msg-container">
            <div className='left'>
                <img src="/assets/image/icon-check.svg" alt="icon" />
                <OverFlowTooltipWithTabsMui value={tabNameChatAI} className="content-msg" />
            </div>
        </div>
    );
}
